import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// eslint-disable-next-line camelcase
import pt_BRLocales from './pt_BR.json';

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt_BR: { translations: pt_BRLocales }
    },
    lng: localStorage.getItem('i18nextLng') || 'pt_BR',
    fallbackLng: 'pt_BR',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
